/// <reference path="DOMAttached.js" />

class DragonChoose extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.options = options;
		this.el = document.getElementById(el);
		this.okButton = document.getElementById(this.options.okButton);
		this.safeObserve(this.okButton, 'click', this.onConfirm.bind(this));
	}

	onConfirm(event) {
		//stop page from reloading
		event.preventDefault();
		event.stopPropagation();

		var first_color;
		var second_color;

		var first_dragons = document.getElementsByName("firstDragon");
		for (var i = 0; i < first_dragons.length; i++) {
			if (first_dragons[i].checked == true) {
				first_color = first_dragons[i].value;
			}
		}
		var second_dragons = document.getElementsByName("secondDragon");
		for (var j = 0; j < second_dragons.length; j++) {
			if (second_dragons[j].checked == true) {
				second_color = second_dragons[j].value;
			}
		}
		var colors = [first_color, second_color];

		if (first_color == second_color) {
			confirmAI(this.options.trSameDragons, function() {}, function() {}, true, false);
		} else {
			axios(new UrlTemplate(this.options.link).r('PLH_CDragonColor', colors).url, {
				method: 'post',
				headers: {
					'content-type': 'application/x-www-form-urlencoded'
				}
			}).then(this.onResponse.bind(this));
		}
	}

	onResponse() {
		window.location.reload();
	}
}
